module.exports = __webpack_public_path__ + "static/media/herobanner_background.21a5c3af.jpg";